var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"tip":_vm.title,"top":""}},[_c('img',{staticClass:"brand-card-img",attrs:{"src":_vm.img}})])}
var staticRenderFns = []

export { render, staticRenderFns }